import axios from "axios";

/*
 * Generates a cancelSource object for request options.
 * Aka a cancellable xhr request.
 */
function genCancelSourceOptions() {
  return {
    cancelSource: axios.CancelToken.source(),
  };
}

export { genCancelSourceOptions };
